import {createSlice, PayloadAction} from "@reduxjs/toolkit";
export type RedirectFlagType = 'transfer' | 'engagement' | null
type  InitialStateType = {
    isInitialized: boolean
    redirectFlag: RedirectFlagType
    appForbidden: string | null
};

const initialState: InitialStateType = {
    isInitialized: false,
    redirectFlag: null,
    appForbidden: ''
}

const slice = createSlice({
    name: "app",
    initialState: initialState,
    reducers: {
        initializeStateOfApp: (state: InitialStateType, action: PayloadAction<boolean>) => {
            state.isInitialized = action.payload
            const item = action.payload
            localStorage.setItem("isInitialized", item.toString());
        },
        setRedirectFlag: (state, action: PayloadAction<RedirectFlagType>) => {
            localStorage.setItem("redirectFlag", action.payload || 'transfer');
            state.redirectFlag = action.payload
        }
    },
});
export const appReducer = slice.reducer;
export const appActions = slice.actions;


